const MuiTypography = {};
export { MuiTypography };

//# sourceMappingURL=typography-overrides.js.map